<h1 mat-dialog-title>Cancelar firma</h1>
<div mat-dialog-content>
  <p>¿Desea cancelar el proceso de firma?</p>


</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">No</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Aceptar</button>
</div>
